/* global Bliss */

export default class SubInline {
  static title = "sub-inline";

  static get isInline() {
    return true;
  }

  static get icons() {
    return {
      subscript: require("!svg-inline-loader?classPrefix!@fortawesome/fontawesome-free/svgs/solid/subscript.svg"),
    };
  }

  static get sanitize() {
    return {
      sub: {},
    };
  }

  constructor({ api, _ }) {
    this.api = api;

    this._buttonElem = null;
  }

  // create button
  render() {
    this._buttonElem = Bliss.create({
      tag: "button",
      type: "button",
      class: this.api.styles.inlineToolButton,
      innerHTML: SubInline.icons.subscript,
    });

    return this._buttonElem;
  }

  // tool button is clicked
  surround(_) {
    document.execCommand("subscript");
  }

  // determine tool state when selection happens
  checkState(_) {
    const isActive = document.queryCommandState("subscript");

    this._buttonElem.classList.toggle(this.api.styles.inlineToolButtonActive, isActive);

    return isActive;
  }
}
